import React, { useState, useEffect } from 'react';
import { useHotel } from '../context/HotelContext';
import apiClient from '../lib/apiClient';
import NoDataError from '../components/NoDataError';

const About = () => {
  const { hotel } = useHotel();
  const [story, setStory] = useState([]);
  const [mission, setMission] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    Promise.all([
      apiClient.get('/api/PageContent/GetBySection/Story'),
      apiClient.get('/api/PageContent/GetBySection/Mission'),
    ])
      .then(([storyData, missionData]) => {
        const sorted = (storyData || []).sort((a, b) =>
          a.contentKey.localeCompare(b.contentKey)
        );
        const missionText = missionData?.[0]?.content || '';
        if (sorted.length === 0 && !missionText) {
          setError(true);
          return;
        }
        setStory(sorted);
        setMission(missionText);
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  const hotelName = hotel?.hotelName || '';

  if (loading) {
    return (
      <div className="fixed inset-0 flex flex-col items-center justify-center bg-white z-50">
        <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mb-6"></div>
        <p className="text-gray-500 text-sm tracking-widest uppercase">Loading</p>
      </div>
    );
  }

  if (error) {
    return <NoDataError message="No content is available for this page yet." />;
  }

  return (
    <div className="overflow-hidden">

      {/* Hero Section */}
      <section
        className="relative h-96 flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(30, 64, 175, 0.7), rgba(30, 64, 175, 0.7)), url(${hotel?.bannerUrl || ''})`
        }}
      >
        <div className="text-center text-white z-10 max-w-4xl px-6">
          <h1 className="mb-4 text-white">About {hotelName}</h1>
          <p className="text-xl">{hotel?.description || ''}</p>
        </div>
      </section>

      {/* Our Story Section */}
      {story.length > 0 && (
        <section className="section-large">
          <div className="container">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-center mb-12">Our Story</h2>
              <div className="space-y-6">
                {story.map((item) => (
                  <p key={item.contentKey} className="text-lg leading-relaxed text-gray-700">
                    {item.content}
                  </p>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Mission Section */}
      {mission && (
        <section className="section bg-blue-50">
          <div className="container">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="mb-8">Our Mission</h2>
              <p className="text-xl leading-relaxed text-gray-700 font-medium">
                {mission}
              </p>
            </div>
          </div>
        </section>
      )}

      {/* CTA Section */}
      <section className="section-large bg-gradient-to-r from-blue-600 to-blue-800 text-white">
        <div className="container text-center">
          <h2 className="mb-6 text-white">{hotelName ? `Experience ${hotelName}` : 'Experience the Difference'}</h2>
          <p className="text-xl mb-8 text-blue-100 max-w-2xl mx-auto">
            Discover what makes us special. Book your stay and become part of our story.
          </p>
          <a href="/rooms" className="btn btn-outline text-lg px-8 py-4">
            Book Your Stay
          </a>
        </div>
      </section>

    </div>
  );
};

export default About;
